module.exports = __webpack_public_path__ + "img/home-3-person.8aabbd5d.png";